import { render, staticRenderFns } from "./CheckRecords.vue?vue&type=template&id=028c1f59&scoped=true"
import script from "./CheckRecords.vue?vue&type=script&lang=js"
export * from "./CheckRecords.vue?vue&type=script&lang=js"
import style0 from "./CheckRecords.vue?vue&type=style&index=0&id=028c1f59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c1f59",
  null
  
)

export default component.exports